import React from 'react'
import { Col, Form, Row } from 'antd'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'

import { Button, Drawer } from 'src/components/Ant'
import {
  Input,
  InputCurrency,
  InputNumber,
  SelectOrganization,
  SelectPolicyRule,
  Switch
} from 'src/components/Formik'
import { PolicyAntiFraud, UserLevel } from 'src/types'

import { initialValues } from './initial-values'
import { VatHint } from './vat-hint'
import * as CSS from './styles'
import validationSchema from './validation-schema'

interface AntiFraudDrawer {
  handleSubmit: (values: PolicyAntiFraud) => void
  meLevelType: UserLevel
  refFormik: React.MutableRefObject<any>
}
export default function AntiFraudDrawer({
  handleSubmit,
  meLevelType,
  refFormik
}: AntiFraudDrawer) {
  const { t } = useTranslation()

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      ref={refFormik}
      render={formikProps => (
        <Drawer
          footer={
            <CSS.DrawerFooterDiv>
              <Button
                onClick={() => {
                  formikProps.resetForm(initialValues)
                }}
                title="common.actions.cancel"
                type="default"
              />
              <CSS.Button
                onClick={() => {
                  formikProps.submitForm()
                }}
                title="common.actions.save"
                type="primary"
              />
            </CSS.DrawerFooterDiv>
          }
          onClose={() => {
            formikProps.resetForm(initialValues)
          }}
          title={
            typeof formikProps.values?.policy_request_receipt_antifraud_id ===
            'number'
              ? t('common.actions.edit')
              : t('common.actions.new')
          }
          visible={Boolean(
            formikProps.values?.policy_request_receipt_antifraud_id
          )}
          width={800}
        >
          <Form onSubmit={formikProps.handleSubmit}>
            <Row gutter={24}>
              <Col span={12}>
                <SelectOrganization
                  disabled={
                    ![UserLevel.SuperAdmin, UserLevel.RealmAdmin].includes(
                      meLevelType
                    )
                  }
                  formikProps={formikProps}
                  label="web.resources.organizations.title"
                  style={{ width: '100%', minWidth: '150px' }}
                />
              </Col>
              <Col span={12}>
                <SelectPolicyRule formikProps={formikProps} />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  formikProps={formikProps}
                  label="web.anti-fraud.description"
                  name="description"
                  placeholder="web.anti-fraud.description-placeholder"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={8}>
                <Switch
                  checkedChildren={t('common.actions.yes')}
                  formikProps={formikProps}
                  iconInfo={<VatHint />}
                  style={{ width: '5rem' }}
                  label="web.anti-fraud.vat-drawer"
                  name="vat"
                  required
                  unCheckedChildren={t('common.actions.no')}
                />
              </Col>
              <Col span={8}>
                <InputCurrency
                  dataTestId=""
                  formikProps={formikProps}
                  label="web.anti-fraud.maximum-value-allowed"
                  min={0}
                  name="value"
                />
              </Col>
              <Col span={8}>
                <InputNumber
                  dataTestId=""
                  formikProps={formikProps}
                  label="web.anti-fraud.maximum-quantity-allowed"
                  min={0}
                  name="quantity"
                />
              </Col>
            </Row>
          </Form>
        </Drawer>
      )}
      validationSchema={validationSchema}
    />
  )
}
